import './Terms.css'
import { useEffect } from "react";
export default function Terms() {
    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth" // Smooth scrolling animation
        });
      }
      useEffect(() => {
        scrollToTop();
      }, []);
    return(
        <>
<section class="banner">
    <h1>Terms and Conditions</h1>
  </section>
        <div className="container-terms">
<h1 className="title-terms">1. Website Usage</h1>
<p className="description-terms">1.1. The website must not be used for any illegal purposes or in violation of these terms.</p>
<p className="description-terms">1.2. The company reserves the right to modify or discontinue the website, or any part of it, at any time without prior notice.</p>
<p className="description-terms">1.3. Users are prohibited from attempting unauthorized access to the website’s systems.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">2. Intellectual Property</h1>
<p className="description-terms">2.1. All content displayed on the website, including text, images, designs, and logos, is owned by the real estate marketing company and is protected under intellectual property laws.</p>
<p className="description-terms">2.2. Copying or republishing any content from the website without prior written consent from the company is prohibited.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">3. Liability</h1>
<p className="description-terms">3.1. The company provides information on the website "as is" without any warranties.</p>
<p className="description-terms">3.2. The company is not liable for any direct or indirect damages resulting from the use of the website.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">4. External Links</h1>
<p className="description-terms">4.1. The website may contain links to other sites. We are not responsible for the content or privacy policies of external sites.</p>
<p className="description-terms">4.2. The inclusion of any links does not imply endorsement.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">5. Privacy Policy</h1>
<p className="description-terms">Please review our Privacy Policy to understand how your personal data is collected, used, and protected.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">6. Changes to Terms and Conditions</h1>
<p className="description-terms">6.1. The company reserves the right to modify these terms and conditions at any time without prior notice.</p>
<p className="description-terms">6.2. It is recommended to review this page regularly to stay informed of any changes.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">7. Governing Law</h1>
<p className="description-terms">These terms and conditions are governed by and interpreted in accordance with the laws of the country where the company operates.</p>
<div style={{height:'30px'}}></div>
<h1 className="title-terms">8. Contact Us</h1>
<p className="description-terms">If you have any inquiries regarding these terms and conditions, please contact us via the email or phone number provided on the website.</p>
<p className="description-terms">Thank you for visiting our website, and we hope to meet your expectations always.</p>

        </div>        </>
    )
}